import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import StringIcon from 'assets/icons/string.svg'
import NumberIcon from 'assets/icons/number.svg'
import BooleanIcon from 'assets/icons/boolean.svg'
import DateTimeIcon from 'assets/icons/datetime.svg'
import EnumIcon from 'assets/icons/enum.svg'
import ObjectIcon from 'assets/icons/object.svg'
import ArrayIcon from 'assets/icons/array.svg'

import styles from './typeIcon.scss'

interface IProps {
  className?: string
  string?: boolean
  int?: boolean
  float?: boolean
  boolean?: boolean
  dateTime?: boolean
  enumerable?: boolean
  array?: boolean
  object?: boolean
  required?: boolean
}

const TypeIcon = ({
  className,
  string = false,
  int = false,
  float = false,
  boolean = false,
  dateTime = false,
  enumerable = false,
  array = false,
  required = false,
}: IProps) => {
  let Component

  if (array) {
    Component = ArrayIcon
  } else if (string) {
    Component = StringIcon
  } else if (int) {
    Component = NumberIcon
  } else if (float) {
    Component = NumberIcon
  } else if (boolean) {
    Component = BooleanIcon
  } else if (enumerable) {
    Component = EnumIcon
  } else if (dateTime) {
    Component = DateTimeIcon
  } else {
    Component = ObjectIcon
  }

  return (
    <>
      <Component className={cn(styles.icon, className)} />
      <span className={styles.required}>{!required && '?'}</span>
    </>
  )
}

export default observer(TypeIcon)
